// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import setShowPricing from "@insite/client-framework/Store/Context/Handlers/SetShowPricing";
import translate from "@insite/client-framework/Translate";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Eye from "@insite/mobius/Icons/Eye";
import EyeOff from "@insite/mobius/Icons/EyeOff";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox/Checkbox";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
/* Starter Custom Code - End */

interface OwnProps {
    extendedStyles?: ShowPricingToggleStyles;
}

export interface ShowPricingToggleStyles {
    toggleClickable?: ClickablePresentationProps;
    toggleIcon?: IconPresentationProps;
    toggleTypography?: TypographyPresentationProps;
    // Starter Custom Code
    wrapper?: InjectableCss;
    checkbox?: CheckboxProps;
}

export const showPricingToggleStyles: ShowPricingToggleStyles = {
    checkbox: {
        variant: "toggle",
        labelPosition: "right",
        sizeVariant: "small",
    },
};

export const ShowPricingToggle = ({ extendedStyles }: OwnProps) => {
    const dispatch = useAppDispatch();
    const showPricing = useAppSelector(state => state.context.showPricing);
    const styles = useMergeStyles("showPricingToggleStyles", showPricingToggleStyles, extendedStyles);

    const clickShowPricingToggleHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.preventDefault();
        dispatch(setShowPricing({ showPricing: !showPricing }));
    };

    return (
        <StyledWrapper {...styles.wrapper} className="show-pricing-toggle" /* Starter Custom Code */>
            {/* Starter Custom Code - Start */}
            <Checkbox
                {...styles.checkbox}
                checked={showPricing}
                onChange={clickShowPricingToggleHandler}
                data-test-selector={showPricing ? "NotShowPricing" : "ShowPricing"}
            >
                {translate("Show Pricing")}
            </Checkbox>
            {/* Starter Custom Code - End */}
        </StyledWrapper>
    );
};

export default ShowPricingToggle;
